import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Row,
  Switch,
  Button,
  Tooltip,
  Select,
} from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import "./style.scss";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { httpService } from "../../../../../services/httpService.service";
import CatalogQuickAdd from "./CatalogQuickAdd";
import AddAdditionalToolModal from "../../SampleSize/AddSampleSize";

const { Option } = Select;

const VisitDetails = ({
  form,
  kills,
  setKills,
  siteContactsRequired,
  setSiteContactsRequired,
  observationList,
  setObservationList,
  addedCustomForms,
  setAddedCustomForms,
  onCancel,
}) => {
  const [customForms, setCustomForms] = useState([]);
  const [availableCustomForms, setAvailableCustomForms] = useState([]);
  const [loading, setLoading] = useState(false);

  // ✅ Fetch custom forms from API
  const fetchAvailableCustomForms = async () => {
    try {
      setLoading(true);
      const projectId = localStorage.getItem("currentProjectID");
      httpService.get(
        `/api/Datachecks/getAll?projectId=${projectId}`,
        (res) => {
          const forms = Array.isArray(res) ? res : res?.data || [];
          setAvailableCustomForms(forms);
          setLoading(false);
        },
        (error) => {
          console.error("Error fetching Datachecks:", error);
          setLoading(false);
        }
      );
    } catch (err) {
      console.error("Unexpected error:", err);
      setLoading(false);
    }
  };

  // ✅ Call API once on mount
  useEffect(() => {
    fetchAvailableCustomForms();
  }, []);

  const handleKillsChange = (value) => {
    setKills(value);
  };

  useEffect(() => {
    if (form) {
      const currentFields = form.getFieldValue("KIIcontacts") || [];
      const updatedFields = Array.from({ length: kills }).map(
        (_, index) => currentFields[index] || {}
      );
      form.setFieldsValue({ KIIcontacts: updatedFields });
    }
  }, [kills, form]);

  const handleCustomFormSelect = (selectedIds) => {
    const updated = selectedIds.map((id) => {
      const existing = addedCustomForms.find((f) => f.id === id);
      if (existing) return existing; // keep previous state
      const selected = availableCustomForms.find((f) => f.id === id);
      return { ...selected, isChecked: true, quantity: 1 };
    });
    setAddedCustomForms(updated);
  };

  useEffect(() => {
    setCustomForms([{ name: "", quantity: 0 }]);
  }, [onCancel]);
  return (
    <div>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            name="dateOfPlannedVisit"
            label="Date of Target Visit"
            rules={[
              {
                required: true,
                message: "Please select the date of the target visit!",
              },
            ]}
          >
            <DatePicker
              showTime
              format="YYYY-MM-DD HH:mm:ss"
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
      </Row>

      <div style={{ marginBottom: 8, paddingTop: "20px" }}>
        <span style={{ fontWeight: "700" }}>IP Point of Contact</span>
        <Form.Item>
          <div className="siteContactsWrapper">
            <Form.Item
              name={["pointContacts", "id"]}
              style={{ display: "none" }}
            >
              <Input type="hidden" />
            </Form.Item>
            <div className="siteContactForm container">
              <div className="row">
                <Form.Item
                  name={["pointContacts", "contactName"]}
                  label="Contact Name"
                  rules={[{ required: true, message: "Contact Name required" }]}
                  className="col-12 col-md-6 col-lg-4"
                >
                  <Input placeholder="Enter text here" />
                </Form.Item>
                <Form.Item
                  className="col-12 col-md-6 col-lg-4"
                  name={["pointContacts", "email"]}
                  label="Email"
                >
                  <Input placeholder="Enter text here" />
                </Form.Item>
                <Form.Item
                  className="col-12 col-md-6 col-lg-4"
                  name={["pointContacts", "role"]}
                  label="Role"
                  rules={[{ required: true, message: "Role required" }]}
                >
                  <Input placeholder="Enter text here" />
                </Form.Item>
                <Form.Item
                  className="col-12 col-md-6 col-lg-4"
                  name={["pointContacts", "organization"]}
                  label="Organization"
                  rules={[{ required: true, message: "Organization required" }]}
                >
                  <Input placeholder="Enter text here" />
                </Form.Item>
                <Form.Item
                  className="col-12 col-md-6 col-lg-4"
                  name={["pointContacts", "phone"]}
                  label="Phone"
                >
                  <Input placeholder="Enter text here" />
                </Form.Item>
                {/* <Form.Item
                  className="col-12 col-md-6 col-lg-4"
                  name={["pointContacts", "skype"]}
                  label="Name of the Tool"
                >
                  <Input placeholder="Enter text here" />
                </Form.Item> */}
              </div>
            </div>
          </div>
        </Form.Item>

        <div style={{ marginBottom: 8, paddingTop: "20px" }}>
          <Form.Item name="siteContactsRequired" valuePropName="checked">
            <Checkbox
              className="d-flex flex-row justify-items-center align-items-center"
              checked={siteContactsRequired}
              onChange={() => {
                const newChecked = !siteContactsRequired; // Toggle the current state
                setSiteContactsRequired(newChecked);
                form.setFieldsValue({ siteContactsRequired: newChecked });
              }}
            >
              <span style={{ fontWeight: "700" }}>
                Site Contacts (optional)
              </span>
            </Checkbox>
          </Form.Item>

          {siteContactsRequired ? (
            <Form.Item>
              <div className="siteContactsWrapper">
                <Form.Item
                  name={["siteContacts", "id"]}
                  style={{ display: "none" }}
                >
                  <Input type="hidden" />
                </Form.Item>

                <div className="siteContactForm container">
                  <div className="row">
                    <Form.Item
                      className="col-12 col-md-6 col-lg-4"
                      name={["siteContacts", "contactName"]}
                      label="Contact Name"
                      rules={[
                        {
                          required: siteContactsRequired,
                          message: "Contact Name required",
                        },
                      ]}
                    >
                      <Input placeholder="Enter text here" />
                    </Form.Item>
                    <Form.Item
                      className="col-12 col-md-6 col-lg-4"
                      name={["siteContacts", "email"]}
                      label="Email"
                    >
                      <Input placeholder="Enter text here" />
                    </Form.Item>
                    <Form.Item
                      className="col-12 col-md-6 col-lg-4"
                      name={["siteContacts", "role"]}
                      label="Role"
                      rules={[
                        {
                          required: siteContactsRequired,
                          message: "Role required",
                        },
                      ]}
                    >
                      <Input placeholder="Enter text here" />
                    </Form.Item>

                    <Form.Item
                      className="col-12 col-md-6 col-lg-4"
                      name={["siteContacts", "organization"]}
                      label="Organization"
                      rules={[
                        {
                          required: siteContactsRequired,
                          message: "Organization required",
                        },
                      ]}
                    >
                      <Input placeholder="Enter text here" />
                    </Form.Item>
                    <Form.Item
                      className="col-12 col-md-6 col-lg-4"
                      name={["siteContacts", "phone"]}
                      label="Phone"
                    >
                      <Input placeholder="Enter text here" />
                    </Form.Item>
                    {/* <Form.Item
                      className="col-12 col-md-6 col-lg-4"
                      name={["siteContacts", "skype"]}
                      label="Name of the tool"
                    >
                      <Input placeholder="Enter text here" />
                    </Form.Item> */}
                  </div>
                </div>
              </div>
            </Form.Item>
          ) : null}
        </div>
      </div>

      <h1
        style={{
          flex: "1 0 0",
          color: "var(--Neutrals-Black, #3A3737)",
          fontFamily: "Poppins",
          fontSize: "22px",
          fontStyle: "normal",
          fontWeight: "600",
          lineHeight: "32px",
        }}
        className="mt-5"
      >
        Sample size
      </h1>
      <div style={{ marginBottom: 8, paddingTop: "25px" }}>
        <Col span={8}>
          <Form.Item
            required
            name="beneficiariesCount"
            label="Beneficiaries Surveys"
          >
            <InputNumber min={0} defaultValue={0} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="kills"
            // required
            label="KII(s)"
            tooltip="Number of KII(s) to be observed"
          >
            <InputNumber min={0} value={kills} onChange={handleKillsChange} />
          </Form.Item>
        </Col>
        {kills > 0 && (
          <>
            <span style={{ fontWeight: "700" }}>KII contacts (optional)</span>
            <Form.List
              name="KIIcontacts"
              initialValue={Array.from({ length: kills })}
            >
              {(fields) => (
                <>
                  <div className="siteContactsWrapper">
                    <div className="siteContactForm">
                      {fields.map((field, index) => (
                        <Row
                          key={field.key}
                          gutter={16}
                          style={{
                            padding: "15px 0",
                            borderBottom:
                              index < fields.length - 1
                                ? "1px solid #FADCEA"
                                : "none",
                          }}
                        >
                          <div className="container">
                            <div className="row">
                              <Form.Item
                                className="col-12 col-md-6 col-lg-4"
                                {...field}
                                name={[field.name, "contactName"]}
                                fieldKey={[field.fieldKey, "contactName"]}
                                label="Contact Name"
                                rules={[
                                  {
                                    required: kills > 0,
                                    message: "Contact Name required",
                                  },
                                ]}
                              >
                                <Input placeholder="Enter text here" />
                              </Form.Item>
                              <Form.Item
                                className="col-12 col-md-6 col-lg-4"
                                {...field}
                                name={[field.name, "email"]}
                                fieldKey={[field.fieldKey, "email"]}
                                label="Email"
                              >
                                <Input placeholder="Enter text here" />
                              </Form.Item>
                              <Form.Item
                                className="col-12 col-md-6 col-lg-4"
                                {...field}
                                name={[field.name, "role"]}
                                fieldKey={[field.fieldKey, "role"]}
                                label="Role"
                                rules={[
                                  {
                                    required: kills > 0,
                                    message: "Role required",
                                  },
                                ]}
                              >
                                <Input placeholder="Enter text here" />
                              </Form.Item>
                              <Form.Item
                                className="col-12 col-md-6 col-lg-4"
                                {...field}
                                name={[field.name, "organization"]}
                                fieldKey={[field.fieldKey, "organization"]}
                                label="Organization"
                                rules={[
                                  {
                                    required: kills > 0,
                                    message: "Organization required",
                                  },
                                ]}
                              >
                                <Input placeholder="Enter text here" />
                              </Form.Item>
                              <Form.Item
                                className="col-12 col-md-6 col-lg-4"
                                {...field}
                                name={[field.name, "phone"]}
                                fieldKey={[field.fieldKey, "phone"]}
                                label="Phone"
                              >
                                <Input placeholder="Enter text here" />
                              </Form.Item>
                              {/* <Form.Item
                                className="col-12 col-md-6 col-lg-4"
                                {...field}
                                name={[field.name, "skype"]}
                                fieldKey={[field.fieldKey, "skype"]}
                                label="Name of the tool"
                              >
                                <Input placeholder="Enter text here" />
                              </Form.Item> */}
                            </div>
                          </div>
                        </Row>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </Form.List>
          </>
        )}
      </div>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            name="ObservationListCheck"
            label="Observation Checklist"
            style={{ marginBottom: 20, marginTop: 20 }}
            valuePropName="checked"
          >
            <Switch
              value={observationList}
              onChange={() => setObservationList(!observationList)}
            />
          </Form.Item>
        </Col>

        {observationList == true ? (
          <Col span={12}>
            <Form.Item
              name="observationChecklistCount"
              label="Observation Checklist"
              required={observationList}
              tooltip="Items to be checked during observation"
            >
              <InputNumber min={0} defaultValue={3} />
            </Form.Item>
          </Col>
        ) : (
          ""
        )}
      </Row>
      <Row>
        {observationList == true ? (
          <Col span={24}>
            <Form.Item
              label="What Type of Observation Checklist?"
              style={{ paddingTop: "20px" }}
              name="observationChecklistType"
            >
              <Input.TextArea rows={3} placeholder="Explain the type of list" />
            </Form.Item>
          </Col>
        ) : (
          ""
        )}
      </Row>

      <div
        className="border p-4"
        style={{ borderRadius: "7px", marginBottom: 20 }}
      >
        <div style={{ maxWidth: "400px" }}>
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
            <h3 className="m-0 p-0">Select Additional Tools</h3>
            <CatalogQuickAdd
              addLabel="New tool"
              manageLabel="Manage tools"
              managePath="/project/planning?sample-size"
              listPath={`/api/Datachecks/getAll?projectId=${localStorage.getItem(
                "currentProjectID"
              )}`}
              createPath="/api/DataChecks"
              buildPayload={(values) => ({
                name: values.name,
                projectId: localStorage.getItem("currentProjectID"),
              })}
              successText="Additional tool added"
              errorText="Failed to add additional tool"
              onCreated={(list, created) => {
                setAvailableCustomForms(list);
                // Tick it on straight from the fetched row —
                // handleCustomFormSelect would look the id up in the
                // pre-refresh list and come back empty.
                if (created?.id) {
                  setAddedCustomForms((prev) =>
                    prev.some((item) => item.id === created.id)
                      ? prev
                      : [...prev, { ...created, isChecked: true, quantity: 1 }]
                  );
                }
              }}
              renderModal={(props) => <AddAdditionalToolModal {...props} />}
            />
          </div>
          <Select
            mode="multiple"
            allowClear
            placeholder={loading ? "Loading forms..." : "Select forms..."}
            style={{ width: "100%" }}
            onChange={handleCustomFormSelect}
            value={addedCustomForms.map((f) => f.id)}
            loading={loading}
          >
            {availableCustomForms.map((form) => (
              <Option key={form.id} value={form.id}>
                {form.name}
              </Option>
            ))}
          </Select>
        </div>

        {addedCustomForms?.map((form, index) => (
          <Row key={form.id} gutter={24} style={{ marginTop: 20 }}>
            <Col span={12}>
              <Form.Item label={form.name} name={`customSample-name-${index}`}>
                <Switch
                  checked={form.isChecked}
                  onChange={(checked) => {
                    const updatedForms = [...addedCustomForms];
                    updatedForms[index] = { ...form, isChecked: checked };
                    if (!checked) updatedForms[index].quantity = 0;
                    setAddedCustomForms(updatedForms);
                  }}
                />
              </Form.Item>
            </Col>

            {form.isChecked && (
              <Col span={12}>
                <Form.Item
                  label={`${form.name} Quantity`}
                  required={form.isChecked}
                  name={`customSample-value-${index}`}
                >
                  <InputNumber
                    onChange={(value) => {
                      const updatedForms = [...addedCustomForms];
                      updatedForms[index] = {
                        ...updatedForms[index],
                        quantity: value,
                      };
                      setAddedCustomForms(updatedForms);
                    }}
                    defaultValue={form.quantity}
                    min={0}
                  />
                </Form.Item>
              </Col>
            )}
          </Row>
        ))}
      </div>

      {/* Render the selected custom forms below */}

      <Row>
        <Col span={24}>
          <Form.Item
            label="Specifics of On-Site Operation"
            style={{ paddingTop: "20px" }}
            name="specificsOfOnSiteOperation"
          >
            <Input.TextArea rows={3} placeholder="Enter instructions" />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item
        name="samplingInstructions"
        label="Sampling Instructions (beneficiaries, sample, profile, selection method, etc)"
      >
        <Input.TextArea rows={3} placeholder="Enter sampling instructions" />
      </Form.Item>
      <Form.Item name="clientInstructions" label="Instructions for any KII(s)">
        <Input.TextArea rows={3} placeholder="Enter instructions" />
      </Form.Item>
      <Form.Item name="otherInstructions" label="Any Other Instructions">
        <Input.TextArea rows={3} placeholder="Enter instructions" />
      </Form.Item>
      <Form.Item name="visitPlanApproval" label="Visit Plan Approver">
        <Input.TextArea rows={3} placeholder="Enter visit plan approver" />
      </Form.Item>
    </div>
  );
};
export default VisitDetails;
